import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { DynamicFormLandingComponent } from '../../../dynamic-form-landing/dynamic-form-landing.component';
import { DynamicFormSection } from 'src/app/_models/widget.models';

/**
 * Dumb/presentational component. Renders the standard widget form body:
 * description text, dynamic form fields, and Cancel/Save action buttons.
 *
 * Has no knowledge of which widget it belongs to — receives all data via
 * @Input and communicates results exclusively via @Output.
 */
@Component({
  selector: 'app-gst-form',
  templateUrl: './gst-form.component.html',
  styleUrls: ['./gst-form.component.scss'],
})
export class GstFormComponent {
  @Input() description: string = '';
  @Input() formSections: DynamicFormSection[] | null = null;
  @Input() formValues: Record<string, any> | null = null;
  @Input() progress: boolean = false;

  @Output() cancelled = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<any>();
  /** Emits the isClosed boolean from the inner calendar/date-picker close event */
  @Output() closeStateChanged = new EventEmitter<boolean>();
  @Output() fetchGst = new EventEmitter<any>();

  @ViewChild(DynamicFormLandingComponent, { static: true })
  private dynamicForm: DynamicFormLandingComponent;

  enableButton: boolean = false;

  onFieldValueChanged(): void {
    this.enableButton = true;
  }

  onSubmit(): void {
    if (this.formSections) {
      const data = this.dynamicForm?.onSubmit();
      if (data?.status === 'VALID') {
        this.submitted.emit(data);
      }
    } else {
      this.submitted.emit(true);
    }
  }

  @HostListener('keydown.enter')
  onEnterKey(): void {
    if (this.enableButton && !this.progress) {
      this.onSubmit();
    }
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onFetchGst(): void {
    this.fetchGst.emit();
  }

  onIsClose(event: Array<any>): void {
    this.closeStateChanged.emit(event[2]);
  }
}
